import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d5e3a1b&"
import script from "./Hostel.ts?vue&type=script&lang=ts&"
export * from "./Hostel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports